import React, { Component } from 'react';
import ReactDOM from 'react-dom';


class HomeCover extends Component{
  render(){
    return(
      <>
      <div className="home-cover">
        <img src={this.props.cover} />
        <div></div>
      </div>
      </>
    );
  }
}

export default HomeCover;
